module.exports = __webpack_public_path__ + "static/media/zoom.b4a79344.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/glove/zoom.JPG
// module id = 54
// module chunks = 0